import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'ngx-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
    @Input() label!: string;
    @Input() removable: boolean = true;
    @Input() status: string = '';
    @Output() remove = new EventEmitter<void>();

    onRemove() {
        this.remove.emit();
    }
}
